<template>
    <q-page>
        <div class="q-display-1">{{title}}</div>

        <q-field label="Nazwa grupy" class="q-mb-xl" label-width="2">
            <q-input v-model="groupId" :disable="hasPublishedModels"/>
        </q-field>

        <AchievementItem
            v-for="groupItem in groupItems"
            :key="groupItem.achievementId"
            :model="groupItem"
            class="q-mr-md"
        />

        <br/>

        <q-btn
            flat
            style="font-size: 1.5rem" dense
            icon="add_circle"
            @click="add"
            color="primary">
            <q-tooltip anchor="top left">
                Dodaj
            </q-tooltip>
        </q-btn>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                @click="save"
                color="primary">
                <q-tooltip anchor="top left">
                    Zapisz
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </q-page>
</template>

<script>
    import FixedButtons from './FixedButtons'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import RepoViewer from './pole/RepoViewer'
    import AchievementItem from './AchievementItem'

    export default {
        name: 'AchievementAdd',
        components: {AchievementItem, RepoViewer, FixedButtons, QTooltip, QBtn},
        data () {
            return {
                groupItems: [],
                groupId: '',
                hasPublishedModels: false,
            }
        },
        methods: {
            createNew (opts = {}) {
                return {
                    achievementId: this.$uuid(),
                    label: 'Nowe osiągnięcie',
                    description: 'Opis...',
                    descriptionWhenAchieved: 'Opis po osiągnięciu...',
                    thumbUrl: '',
                    groupId: 'Nienazwana grupa',
                    pos: 0,
                    counterThresholds: {},
                    isNew: true,
                    ...opts,
                }
            },
            add () {
                this.groupItems.push(this.createNew({
                    groupId: this.groupId,
                }))
            },
            async save () {
                const items = JSON.parse(JSON.stringify(this.groupItems))
                await items.reduce(async (promise, item, pos) => {
                    await promise

                    const {isNew, counterThresholds = {}, originalCounterThresholds = {}, ...data} = {
                        ...item,
                        pos,
                    }

                    const fun = async () => {
                        await Object.keys(originalCounterThresholds).reduce(async (p, id) => {
                            await p

                            return this.$store.dispatch('remove', {
                                what: 'achievementRule',
                                achievementId: data.achievementId,
                                pathParams: {achievementId: data.achievementId},
                                force: true,
                                id,
                            })
                        }, Promise.resolve([]))

                        await Object.keys(counterThresholds).reduce(async (p, id) => {
                            await p

                            const item = {
                                rule: id,
                                points: counterThresholds[id],
                                achievementId: data.achievementId,
                            }

                            await this.$store.dispatch('create', {
                                what: 'achievementRule',
                                achievementId: data.achievementId,
                                pathParams: {achievementId: data.achievementId},
                                dontfetch: true,
                                force: true,
                                item,
                            })

                            return Promise.resolve([])
                        }, Promise.resolve([]))

                        return this.fetchAllAchievementRules();
                    }

                    const payload = {
                        what: 'achievement',
                        item: data,
                    }

                    if (isNew) {
                        await this.$store.dispatch('create', payload)
                        await fun()
                    } else {
                        await this.$store.dispatch('update', {
                            ...payload,
                            dontstore: true,
                            dontfetch: true
                        })
                        const isPublished = data.publicationInformation &&
                            data.publicationInformation.status !== 'Unpublished'

                        if (!isPublished) {
                            await fun()
                        } else {
                            this.fetchAllAchievementRules()
                        }
                    }
                    return Promise.resolve([])
                }, Promise.resolve([]))

                if (!this.editMode) {
                    this.$router.push({name: 'achievements-edit', params: {groupId: this.groupId}});
                }
            },
            async refreshAllAchievements () {
                return this.groupItems.reduce(async (p, item) => {
                    await p

                    try {
                        await this.$store.dispatch('fetch', {
                            what: 'achievement',
                            id: item.achievementId
                        })
                    } catch (e) {
                        // ...
                    }
                }, Promise.resolve([]))
            },
            fetchAllAchievementRules () {
                this.groupItems.reduce(async (p, item) => {
                    await p

                    try {
                        await this.fetchAchievementRules(item.achievementId)
                    } catch (e) {
                        // ...
                    }

                    return this.refreshAllAchievements();
                }, Promise.resolve([]))
            },
            async fetchAchievementRules (achievementId) {
                const data = await this.$store.dispatch('fetchAll', {
                    what: 'achievementRule',
                    dontstore: true,
                    force: true,
                    pathParams: {
                        achievementId,
                    },
                })

                let counterThresholds = {}
                if (data && data.data.counterThresholds) {
                    counterThresholds = data.data.counterThresholds
                }

                this.groupItems = this.groupItems.map(g => {
                    if (g.achievementId === achievementId) {
                        return {
                            ...g,
                            counterThresholds: counterThresholds || {},
                            originalCounterThresholds: counterThresholds || {},
                        }
                    }

                    return g
                })

                return Promise.resolve([])
            },
            initRules () {
                if (this.editMode) {
                    const data = this.$store.getters.achievement.filter(a => {
                        return a.groupId === this.$route.params.groupId
                    })

                    this.groupItems = JSON.parse(JSON.stringify(data)).sort((a, b) => a.pos > b.pos ? 1 : -1)
                    if (this.groupItems) {
                        this.fetchAllAchievementRules()
                    }
                } else {
                    this.groupItems = [this.createNew()]
                }
            }
        },
        watch: {
            groupItems (curr) {
                if (curr.length > 0) {
                    this.groupId = curr[0].groupId

                    this.hasPublishedModels = curr.filter(m => {
                        return m.publicationInformation && m.publicationInformation.status !== 'Unpublished'
                    }).length > 0
                }
            },
            groupId (newGroupId) {
                this.groupItems = this.groupItems.map(item => ({
                    ...item,
                    groupId: newGroupId,
                }))
            },
            fullModel (m) {
                if (m) {
                    this.groupItems = JSON.parse(JSON.stringify(m)).sort((a, b) => a.pos > b.pos ? 1 : -1)

                    if (m.length > 0) {
                        this.groupId = this.groupItems[0].groupId
                    }

                    this.fetchAllAchievementRules()
                }
            },
        },
        computed: {
            editMode () {
                return !!this.$route.params.groupId
            },
            title () {
                if (this.editMode) {
                    return `Edycja grupy "${this.$route.params.groupId}"`
                } else {
                    return 'Dodawanie grupy osiągnięć'
                }
            },
            fullModel () {
                if (this.editMode) {
                    return this.$store.getters.achievement.filter(({groupId}) => groupId === this.$route.params.groupId)
                }
            },
        },
        mounted () {
            this.initRules();

            this.$store.commit('showRightMenu', {
                'showPicture': true,
            })

            this.$on('hook:beforeDestroy', () => {
                this.$store.commit('showRightMenu', false)
            })
        },
    }
</script>